import React from 'react';
import styles from './SuccessBanner.module.css';

export const SuccessBanner: React.FC = () => {
  return (
    <div className={styles.banner}>
      <span className={styles.iconCircle}>✓</span>
      <div>
        <p className={styles.title}>Great Progress!</p>
        <p className={styles.body}>
          You're 68% towards your monthly revenue goal. With 26 more orders, you'll
          exceed your target!
        </p>
        <button className={styles.cta}>View AI Recommendations →</button>
      </div>
    </div>
  );
};
